var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shown.length)?_c('div',{staticClass:"sensor-readings"},_vm._l((_vm.shown),function(one){return _c('div',{key:one.label,staticClass:"sensor-reading"},[_c('div',{staticClass:"sensor-reading-label"},[_vm._v(_vm._s(_vm.$t(one.label)))]),_c('div',{staticClass:"sensor-reading-value"},[_vm._v(_vm._s(one.text))])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }